import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode } from 'primereact/api';
import { Card } from 'primereact/card';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { InputNumber } from 'primereact/inputnumber';
import './ProductList.css';

const AssignProduct = () => {
    const navigate = useNavigate();
    const toast = useRef(null);
    const dt = useRef(null);

    const [auth, setAuth] = useState({ userid: null, branchid: null, clientid: null });
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [cartItems, setCartItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    useEffect(() => {
        setAuth({
            userid: localStorage.getItem('userid'),
            branchid: localStorage.getItem('branchid'),
            clientid: localStorage.getItem('clientid')
        });
    }, []);

    useEffect(() => {
        if (auth.branchid) {
            axios
                .get(`https://treatway.co.in/Counter-Backend/api/server_masters/get_customers/${auth.clientid}`)
                .then((res) => {
                    const list = res.data.map((c) => ({ name: c.company_name, code: c.cust_id }));
                    setCustomers(list);
                })
                .catch((err) => console.error('Customer Fetch Error:', err));
        }
    }, [auth.branchid]);

    const onCustomerChange = (e) => {
        setSelectedCustomer(e.value);
        setSelectedCategory(null);
        setSelectedProduct(null);
        setFilteredProducts([]);

        axios.get(`https://treatway.co.in/Counter-Backend/api/server_masters/get_asgcategories/${auth.clientid}`).then((res) => {
            const list = res.data.map((c) => ({ name: c.pr_cat_name, code: c.pr_cat_code }));
            setFilteredCategories(list);
        });
    };

    const onCategoryChange = (e) => {
        const category = e.value;
        setSelectedCategory(category);
        setSelectedProduct(null);
        axios
            .get(`https://treatway.co.in/Counter-Backend/api/server_masters/get_unassigned_products/${category.code}/${auth.clientid}/${selectedCustomer?.code}`)
            .then((res) => {
                const list = (res.data || []).map((p) => ({
                    id: p.pr_id,
                    name: p.product_name,
                    basic_rate: parseFloat(p.basic_rate) || 0,
                    tax: parseFloat(p.basic_tax_percent) || 0,
                    category_name: category.name,
                    category_id: p.prcat_cat_id,
                    branch_id: p.branch_id
                }));
                setFilteredProducts(list);
            })
            .catch(() => setFilteredProducts([]));
    };

    const addToCart = () => {
        if (selectedProduct && !cartItems.some((item) => item.id === selectedProduct.id)) {
            setCartItems([...cartItems, { ...selectedProduct }]);
        }
        setSelectedProduct(null);
    };

    const updateCartItem = (id, field, value) => {
        setCartItems((prev) => prev.map((item) => (item.id === id ? { ...item, [field]: value } : item)));
    };

    const handleSaveProduct = async () => {
        const payload = {
            branchid: auth.branchid,
            userid: auth.userid,
            clientid: auth.clientid,
            customer_id: selectedCustomer?.code,
            items: cartItems.map((item) => {
                const tax_amount = (item.basic_rate * item.tax) / 100;
                return {
                    id: item.id,
                    basic_rate: parseFloat(item.basic_rate.toFixed(2)),
                    tax: item.tax,
                    tax_amount: parseFloat(tax_amount.toFixed(2)),
                    total_price: parseFloat((item.basic_rate + tax_amount).toFixed(2)),
                    category_id: item.category_id,
                    branch_id: item.branch_id
                };
            })
        };

        setLoading(true);
        try {
            const res = await axios.post('https://treatway.co.in/Counter-Backend/api/server_masters/assignProduct', payload);
            if (res.data.status) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 });
                setTimeout(() => navigate('/viewassignedproduct'), 2000);
            } else {
                toast.current.show({ severity: 'warn', summary: 'Product assigned Failed', detail: res.data.message, life: 4000 });
            }
        } catch (err) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Network Error' });
        } finally {
            setLoading(false);
        }
    };

    const confirmSave = () => {
        confirmDialog({
            message: 'Are you sure you want to submit?',
            header: 'Confirm Submission',
            icon: 'pi pi-exclamation-triangle',
            accept: handleSaveProduct,
            acceptLabel: 'Yes, Proceed',
            rejectLabel: 'Cancel',
            acceptClassName: 'p-button-success',
            rejectClassName: 'p-button-text'
        });
    };

    const handleResetFilters = () => {
        setSelectedCustomer(null);
        setSelectedCategory(null);
        setSelectedProduct(null);
        setFilteredCategories([]);
        setFilteredProducts([]);
        setGlobalFilterValue('');
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
    };

    const removeFromCart = (id) => {
        setCartItems(cartItems.filter((i) => i.id !== id));
    };

    return (
        <div className="petpooja-category-master">
            <Toast ref={toast} />
            <ConfirmDialog />

            {/* Top Navigation Bar */}
            <div className="petpooja-topbar">
                <div className="topbar-left">
                    <div className="topbar-icon">
                        <i className="pi pi-shopping-cart"></i>
                    </div>
                    <h2>Assign Products</h2>
                </div>
                <div className="topbar-right">
                    <Dropdown value={selectedCustomer} options={customers} onChange={onCustomerChange} optionLabel="name" placeholder="Select Customer" filter showClear className="topbar-dropdown" />
                    <Dropdown
                        value={selectedCategory}
                        options={filteredCategories}
                        onChange={onCategoryChange}
                        optionLabel="name"
                        placeholder={selectedCustomer ? 'Select Category' : 'Select Customer First'}
                        disabled={!selectedCustomer}
                        filter
                        showClear
                        className="topbar-dropdown"
                    />
                    <Dropdown
                        value={selectedProduct}
                        options={filteredProducts}
                        onChange={(e) => setSelectedProduct(e.value)}
                        optionLabel="name"
                        placeholder={selectedCategory ? 'Select Product' : 'Select Category First'}
                        disabled={!selectedCategory}
                        filter
                        showClear
                        className="topbar-dropdown"
                    />
                    <Button label="Add to List" icon="pi pi-plus" className="petpooja-btn-primary" onClick={addToCart} disabled={!selectedProduct} />
                    <Button icon="pi pi-filter-slash" className="reset-btn-green" onClick={handleResetFilters} />
                </div>
            </div>

            {/* Main Content */}
            <div className="petpooja-content">
                {/* Statistics Section */}
                <div className="petpooja-stats-container">
                    <Card className="petpooja-stat-card total">
                        <div className="stat-content">
                            <div className="stat-info">
                                <span className="stat-label">Total Items</span>
                                <div className="stat-value">{cartItems.length}</div>
                            </div>
                            <div className="stat-icon-wrapper total-icon">
                                <i className="pi pi-list"></i>
                            </div>
                        </div>
                    </Card>

                    <Card className="petpooja-stat-card active">
                        <div className="stat-content">
                            <div className="stat-info">
                                <span className="stat-label">Selected Customer</span>
                                <div className="stat-value" style={{ fontSize: '1rem' }}>
                                    {selectedCustomer?.name || 'None'}
                                </div>
                            </div>
                            <div className="stat-icon-wrapper active-icon">
                                <i className="pi pi-user"></i>
                            </div>
                        </div>
                    </Card>

                    <Card className="petpooja-stat-card inactive">
                        <div className="stat-content">
                            <div className="stat-info">
                                <span className="stat-label">Selected Category</span>
                                <div className="stat-value" style={{ fontSize: '1rem' }}>
                                    {selectedCategory?.name || 'None'}
                                </div>
                            </div>
                            <div className="stat-icon-wrapper inactive-icon">
                                <i className="pi pi-tag"></i>
                            </div>
                        </div>
                    </Card>
                </div>

                {/* Table Section */}
                {cartItems.length > 0 ? (
                    <Card className="petpooja-table-card">
                        <div className="petpooja-table-header">
                            <div className="table-header-left">
                                <h3>Product Assignment List</h3>
                                <span className="records-count">({cartItems.length} items)</span>
                            </div>
                            <div className="table-header-right">
                                <span className="p-input-icon-left search-box">
                                    <i className="pi pi-search" />
                                    <InputText
                                        value={globalFilterValue}
                                        onChange={(e) => {
                                            setGlobalFilterValue(e.target.value);
                                            setFilters({
                                                ...filters,
                                                global: { value: e.target.value, matchMode: FilterMatchMode.CONTAINS }
                                            });
                                        }}
                                        placeholder="Search products..."
                                        className="search-input"
                                    />
                                </span>
                                <Button label="Save All" icon="pi pi-save" className="petpooja-btn-export" onClick={confirmSave} />
                            </div>
                        </div>

                        <DataTable
                            ref={dt}
                            value={cartItems}
                            loading={loading}
                            editMode="cell"
                            filters={filters}
                            className="petpooja-datatable"
                            emptyMessage={
                                <div className="empty-message">
                                    <i className="pi pi-inbox"></i>
                                    <p>No products in cart</p>
                                </div>
                            }
                        >
                            <Column field="category_name" header="Category" sortable />
                            <Column field="name" header="Product" sortable />
                            <Column field="basic_rate" header="Basic Price" body={(row) => row.basic_rate.toFixed(2)} sortable />
                            <Column
                                field="tax"
                                header="Tax (%)"
                                editor={(options) => (
                                    <InputNumber
                                        value={options.value}
                                        onValueChange={(e) => {
                                            updateCartItem(options.rowData.id, 'tax', e.value);
                                            options.editorCallback(e.value);
                                        }}
                                    />
                                )}
                                body={(row) => (
                                    <div className="flex align-items-center justify-content-center gap-2">
                                        <span>{row.tax}%</span>
                                        <i className="pi pi-pencil text-400" style={{ fontSize: '0.8rem' }} />
                                    </div>
                                )}
                                sortable
                            />
                            <Column
                                header="Total"
                                editor={(options) => (
                                    <InputNumber
                                        value={Math.round(options.rowData.basic_rate * (1 + options.rowData.tax / 100))}
                                        onValueChange={(e) => {
                                            const newBasic = e.value / (1 + options.rowData.tax / 100);
                                            updateCartItem(options.rowData.id, 'basic_rate', newBasic);
                                            options.editorCallback(e.value);
                                        }}
                                    />
                                )}
                                body={(row) => (
                                    <div className="flex align-items-center justify-content-center gap-2">
                                        <span>{(row.basic_rate * (1 + row.tax / 100)).toFixed(2)}</span>
                                        <i className="pi pi-pencil text-400" style={{ fontSize: '0.8rem' }} />
                                    </div>
                                )}
                                sortable
                            />
                            <Column body={(row) => <Button icon="pi pi-trash" className="p-button-danger p-button-sm p-button-rounded" onClick={() => removeFromCart(row.id)} />} header="Actions" style={{ width: '100px' }} />
                        </DataTable>
                    </Card>
                ) : (
                    <Card className="petpooja-table-card">
                        <div className="empty-message" style={{ padding: '4rem' }}>
                            <i className="pi pi-shopping-cart" style={{ fontSize: '4rem' }}></i>
                            <p style={{ fontSize: '1.25rem', marginTop: '1rem' }}>Product list is empty</p>
                            <p style={{ color: '#64748b', marginTop: '0.5rem' }}>Select customer, category and product to add items</p>
                        </div>
                    </Card>
                )}
            </div>
        </div>
    );
};

export default AssignProduct;
